import styled from 'styled-components'

interface BrandPanelProps {
  variant?: 'admin' | 'evaluated'
}

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background:
    radial-gradient(circle at top left, rgba(198, 1, 107, 0.12), transparent 32%),
    radial-gradient(circle at bottom right, rgba(45, 116, 156, 0.14), transparent 28%),
    linear-gradient(180deg, #f4f8fc 0%, #eef4f9 100%);
`

export const Content = styled.div`
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(380px, 0.95fr);
  align-items: stretch;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 32px;

  @media (max-width: 768px) {
    padding: 28px 18px;
  }
`

export const BrandPanel = styled.aside<BrandPanelProps>`
  position: relative;
  overflow: hidden;
  background: ${(props) =>
    props.variant === 'evaluated'
      ? `radial-gradient(circle at 18% 18%, rgba(255, 255, 255, 0.18), transparent 22%),
         radial-gradient(circle at 80% 24%, rgba(198, 1, 107, 0.22), transparent 18%),
         linear-gradient(160deg, #245d7d 0%, #2d749c 46%, #5dbf1a 100%)`
      : `radial-gradient(circle at 18% 18%, rgba(255, 255, 255, 0.2), transparent 22%),
         radial-gradient(circle at 78% 28%, rgba(198, 1, 107, 0.32), transparent 18%),
         linear-gradient(160deg, #183449 0%, #214b67 54%, #2d749c 100%)`};
  padding: 56px 52px;
  display: flex;
  align-items: flex-end;

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 999px;
    filter: blur(8px);
  }

  &::before {
    width: 320px;
    height: 320px;
    right: -90px;
    top: -110px;
    background: rgba(255, 255, 255, 0.08);
  }

  &::after {
    width: 240px;
    height: 240px;
    left: -80px;
    bottom: -110px;
    background: ${(props) => (props.variant === 'evaluated' ? 'rgba(93, 191, 26, 0.16)' : 'rgba(198, 1, 107, 0.14)')};
  }

  @media (max-width: 1100px) {
    display: none;
  }
`

export const BrandPanelContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: #ffffff;
`

export const BrandImage = styled.img`
  width: min(100%, 340px);
  height: auto;
  display: block;
  margin-bottom: 16px;
`

export const BrandHeadline = styled.h2`
  margin: 0;
  color: #ffffff;
  font-family: 'Public Sans', sans-serif;
  font-size: clamp(2rem, 2.6vw, 3.2rem);
  font-weight: 800;
  line-height: 1.02;
  letter-spacing: -0.04em;
`

export const BrandSubtitle = styled.p`
  margin: 0;
  max-width: 430px;
  color: rgba(255, 255, 255, 0.84);
  font-family: 'Public Sans', sans-serif;
  font-size: 1.02rem;
  line-height: 1.65;
`

export const BrandPillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`

export const BrandPill = styled.div`
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  backdrop-filter: blur(12px);
`
